import { AxiosError } from 'axios';

import { Completable, EmployerSummaryDTO, KashableResponseDTO } from 'kashable-mobile-common';

import { errored, mapSucceeded } from '../utils/AxiosUtils';

import axios from './base';


const fetchEmployer: () => Promise<Completable<EmployerSummaryDTO>> = () => {
    return axios
        .get<KashableResponseDTO<EmployerSummaryDTO>>('/secured/user/employer')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};


export { fetchEmployer };
